export default __webpack_public_path__ + "static/media/medical.9fecba28.svg";